module.exports = __webpack_public_path__ + "img/calendar4.d5f4b1b0.svg";